import { render, staticRenderFns } from "./sex-select.vue?vue&type=template&id=b58a6f00&scoped=true&"
import script from "./sex-select.vue?vue&type=script&lang=js&"
export * from "./sex-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58a6f00",
  null
  
)

export default component.exports